import { LOCAL__generation_set_generation_id_next } from '@/state/generation/LOCAL__generation_set_generation_id_next';
import { store } from '@/state/store';
import { assert_string_object_id_not_empty } from '@shared/asserts/utils_asserts';
import { logi } from '@shared/utils/utils_logs';

export function HANDLER_CLIENT__generation_next_created(generation_id: any) {
  assert_string_object_id_not_empty(generation_id);

  logi(`🆕 new generation created\t\t${generation_id}`);

  store.dispatch(LOCAL__generation_set_generation_id_next(generation_id));
}
